<template>
  <nav v-if="breadcrumbs.length" class="flex" aria-label="Breadcrumb">
    <ol role="list" class="flex items-center space-x-4">
      <li>
        <div>
          <a href="/admin" class="text-gray-400 hover:text-gray-500">
            <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z" clip-rule="evenodd" />
            </svg>
            <span class="sr-only">Home</span>
          </a>
        </div>
      </li>
      <li v-for="(crumb, idx) in breadcrumbs" :key="`breadcrumb-${idx}`">
        <div class="flex items-center">
          <svg class="h-5 w-5 shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
            <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
          </svg>
          <inertia-link v-if="crumb.url" :href="crumb.url" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">{{ crumb.name }}</inertia-link>
          <span v-else class="ml-4 text-sm font-medium text-gray-500">{{ crumb.name }}</span>
        </div>
      </li>
      <!-- <li>
        <div class="flex items-center">
          <svg class="h-5 w-5 shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
            <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
          </svg>
          <a href="#" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700" aria-current="page">Project Nero</a>
        </div>
      </li> -->
    </ol>
  </nav>

</template>
<script>

export default {
  //
  methods: {
    makePageCrumbs(page) {
      if (!page) {
        return [];
      }
      if (page.parent) {
        return [{
          name: page.name,
          url: route('cms.pages.show', page.id)
        }].concat(this.makePageCrumbs(this.$page.props.pages.find(p => p.id == page.parent)))
      } else {
        return [{
          name: page.name,
          url: route('cms.pages.show', page.id)
        }];
      }
    }
  },
  computed: {
    breadcrumbs() {
      const inertiaProps = this.$page.props;
      let crumbs = [];
      if (route().current('cms.pages.*')) {
        // Page item
        crumbs.push({
          name: 'Pages',
          url: '/admin/pages'
        });
        if (inertiaProps.page?.id) {
          const pages = this.makePageCrumbs(inertiaProps.page);
          crumbs = crumbs.concat(pages.reverse());
        } else if (route().current('cms.pages.create')) {
          crumbs.push({
            name: 'New Page'
          });
        }
      } else if (route().current('cms.mod.*')) {
        // Module item
        // item.id ? mod edit : mod create
        if (inertiaProps.parent) {
          // console.log('TODO: child module')
          // We are in a child module. could be listing or detail
          if (inertiaProps.item) {
            // Child detail page
            crumbs.push({
              name: `Module: ${inertiaProps.mod.parent.name}`,
              url: route('cms.mod.index', {module: inertiaProps.mod.parent.id})
            });
            if (inertiaProps.parent) {
              // Module detail page
              crumbs.push({
                name: inertiaProps.parent.name || inertiaProps.parent.title || inertiaProps.parent.id,
                url: route('cms.mod.show', {module: inertiaProps.mod.parent.id, id: inertiaProps.parent.id})
              });
            }
            crumbs.push({
              name: `Module: ${inertiaProps.mod.name}`,
              url: route('cms.mod.child.index', {module: inertiaProps.mod.parent.id, parent: inertiaProps.parent.id, child: inertiaProps.mod.id})
            });
            if (inertiaProps.item?.id) {
              crumbs.push({
                name: inertiaProps.item.name || inertiaProps.item.title || inertiaProps.item.id,
                url: route('cms.mod.child.show', {module: inertiaProps.mod.parent.id, parent: inertiaProps.parent.id, child: inertiaProps.mod.id, id: inertiaProps.item.id})
              });
            } else {
              crumbs.push({
                name: 'New Item',
              });
            }
          } else {
            crumbs.push({
              name: `Module: ${inertiaProps.parent.mod.name}`,
              url: route('cms.mod.index', {module: inertiaProps.parent.mod.id})
            });
            if (inertiaProps.parent.item) {
              // Module detail page
              crumbs.push({
                name: inertiaProps.parent.item.name || inertiaProps.parent.item.title || inertiaProps.parent.item.id,
                url: route('cms.mod.show', {module: inertiaProps.parent.mod.id, id: inertiaProps.parent.item.id})
              });
            }
            crumbs.push({
              name: `Module: ${inertiaProps.mod.name}`,
              url: route('cms.mod.child.index', {module: inertiaProps.parent.mod.id, parent: inertiaProps.parent.item.id, child: inertiaProps.mod.id})
            });
          }
        } else if (inertiaProps.mod) {
          // console.warn(inertiaProps);
          crumbs.push({
            name: `Module: ${inertiaProps.mod.name}`,
            url: route('cms.mod.index', {module: inertiaProps.mod.id})
          });
          if (inertiaProps.item?.id) {
            // Module detail page
            crumbs.push({
              name: inertiaProps.item.name || inertiaProps.item.title || inertiaProps.item.id,
              url: route('cms.mod.show', {module: inertiaProps.mod.id, id: inertiaProps.item.id})
            });
          } else if (route().current('cms.mod.create')) {
            crumbs.push({
              name: 'New Item'
            })
          }
        }
      } else if (inertiaProps.pageName) {
        crumbs.push({
          name: inertiaProps.pageName
        });
      }
      return crumbs;
    }
  }
}

</script>
